'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
let app = window.app;
class WrappedSelect extends PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    let value = e.target.value;
    props.onChange({
      e: e,
      value: value,
      name: props.name,
      source: 'native'
    });
  };
  getLabelOption = value => {
    const component = this,
      props = this.props,
      state = this.state;
    let current_option = (props.getOptions() || []).find(option => option.value === value);
    return current_option?.label || '';
  };
  removeDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const scroll_width = window.innerWidth - document.body.clientWidth;
    let scroll_area = document.querySelector('.front-page, .back-page');
    scroll_area.style.paddingRight = scroll_width + 'px';
    document.querySelector('html').classList.add('u-lock-scroll-' + props._id);
  };
  restoreDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const html = document.querySelector('html');
    if (html.className.split('u-lock-scroll-').length > 2 === false) {
      let scroll_area = document.querySelector('.front-page, .back-page');
      scroll_area.style.paddingRight = '';
    }
    html.classList.remove('u-lock-scroll-' + props._id);
  };
  renderValue = values => {
    const component = this,
      props = this.props,
      state = this.state;
    return values.map(function (value, i) {
      const label = component.getLabelOption(value);
      return (i > 0 ? ', ' : '') + label;
    });
  };
  render() {
    const component = this,
      props = this.props;
    let error_msg,
      status = props.status[props.name] || {};
    let class_name = props.className;
    const id = props.id || String(++app.form_index);
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    class_name += ' mui-select';
    if (status && status.error) {
      error_msg = /*#__PURE__*/React.createElement(FormHelperText, null, status.error);
    }
    const options = props.getOptions().map(function (option, key) {
      let output = /*#__PURE__*/React.createElement(MenuItem, {
        key: key,
        value: option.value
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: props.value.indexOf(option.value) > -1
      }), /*#__PURE__*/React.createElement(ListItemText, {
        primary: option.label || option.value || ''
      }));
      return output;
    });
    let styles = {
      ...props.style
    };
    if (props['no-margin']) {
      styles = {
        formControl: {
          marginTop: 0
        }
      };
    }
    const label = props.label ? /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: id
    }, props.label) : undefined;
    const value = typeof props.value === 'undefined' ? props['default-value'] : props.value;
    let output = /*#__PURE__*/React.createElement("div", {
      className: class_name,
      style: props.style
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: props['full-width'],
      error: Boolean(status.error),
      style: styles
    }, label, /*#__PURE__*/React.createElement(Select, {
      id: id,
      onChange: component.handleChange,
      multiple: true,
      value: value,
      name: props.name,
      required: props.required,
      input: /*#__PURE__*/React.createElement(Input, null),
      renderValue: component.renderValue,
      disablescrolllock: "true",
      MenuProps: {
        disableScrollLock: true
      },
      onOpen: component.removeDocumentScroll,
      onClose: component.restoreDocumentScroll,
      disabled: props['read-only'] === true
    }, options), error_msg));
    return output;
  }
}
WrappedSelect.propTypes = {
  'no-value-option': PropTypes.bool,
  'full-width': PropTypes.bool,
  'no-margin': PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  status: PropTypes.object.isRequired,
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired
};
WrappedSelect.defaultProps = {
  'no-value-option': true,
  'full-width': true,
  'no-margin': false,
  required: false,
  'default-value': '',
  className: '',
  style: {}
};
export default class SelectStore extends Component {
  retrieveOptions = () => {
    return this.options;
  };
  render() {
    this.options = this.props.options;
    return /*#__PURE__*/React.createElement(WrappedSelect, _extends({}, this.props, {
      options: undefined,
      getOptions: this.retrieveOptions
    }));
  }
}
SelectStore.propTypes = {
  options: PropTypes.array.isRequired
};
